<template>
    
    <md-card>
          <!-- <md-card-header class="md-card-header-icon">
            <div class="card-icon">
              <md-icon>design_services</md-icon>
            </div>
            <h4 class="title">
              Part Step
            </h4>
          </md-card-header> -->
          <md-card-content>
            <autoextra :collection="part" v-slot="{item,last,index}">
              <div class="columns" :class="{last: last}">
                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-size-100">
                    <label class="label">{{last ? 'New ' : ''}}Part {{!last ? index + 1 : ''}}</label>
                  </div>
                  <div class="md-layout-item md-size-10">
                    <md-button class="md-primary md-round md-dense" v-on:click="findPart(index)">Find Sparepart</md-button>
                   </div>
                </div>

                <div class="md-layout md-gutter">
                  <input v-model="item.id" :readonly="true" type="hidden"/>
                  <input v-model="item.pkb_spare_part_master_id" :readonly="true" type="hidden"/>

                  <!-- <div class="md-layout-item md-small-size-100">
                    <md-field class="md-invalid">
                      <label class="label" >Part Name</label>
                      <validation-provider  ref="spare_part_master_name"  v-slot="{ errors }">
                      <md-select v-model="item.pkb_spare_part_master_id" @md-selected="onChangePart(index, $event)" @focus="focusSelectChanged(index)">
                        <md-option v-for="option in options_part_list" :key="option.value" :value="option.id">
                          {{ '('+option.spare_part_master_code+') '+option.spare_part_master_name }}
                        </md-option>
                      </md-select>
                      <span >{{ errors[0] }}</span>
                      </validation-provider>
                    </md-field>
                  </div> -->

                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Part Nama</label>
                        <validation-provider ref="spare_part_master_name"  v-slot="{ errors }">
                          <md-input  v-model="item.name" :readonly="true"/>
                          <span >{{ errors[0] }}</span>
                        </validation-provider>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Part Code</label>
                      <md-input  v-model="item.code" :readonly="true"/>
                  
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-50">
                    <md-field >
                      <label class="label" >Part Stock</label>
                      <md-input  v-model="item.stock" :readonly="true"/>
                  
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-50">
                    <md-field >
                      <label class="label" >Price</label>
                      <md-input  v-model="item.price" :readonly="true"/>
                   
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-50">
                    <md-field >
                      <label class="label" >Quantity</label>
                      <md-input :max='item.stock'  v-model="item.pkb_spare_part_qty" @change="qtyChange(index,item.pkb_spare_part_qty)" type="text" v-on:keypress="NumbersOnly"/>
                  
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-50">
                    <md-field >
                      <label class="label" >Discount(%)</label>
                      <md-input v-model="item.pkb_spare_part_discount" @change="discountChange(index,item.pkb_spare_part_discount)" type="text" v-on:keypress="NumbersOnly"/>
                  
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Total</label>
                      <md-input  v-model="item.total" :readonly="true"/>
                  
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Remarks</label>
                      <md-input  v-model="item.pkb_spare_part_remark" />
                  
                    </md-field>
                  </div>
                  
                  <md-card-actions style="border:none;">
                  <md-button class="md-danger md-dense" @click="deleteColumn(index)" v-if="item.code">
                    delete
                  </md-button>
                </md-card-actions>
                </div>            
              </div>
            </autoextra>
          </md-card-content>
          <modal ref="modalList" class="coba">
                    <template v-slot:header>
                      <h3>List Part</h3>
                    </template>

                    <template v-slot:body>
                      <list-part  :data_id="$refs.modalList.data"/>
                    </template>

                    <template v-slot:footer>
                      <md-card-actions>
                        <md-button @click="modalCloseList">
                          Close
                        </md-button>
                      </md-card-actions>
                    </template>
                </modal>
        </md-card>  
        
</template>
<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import  Autoextra  from 'vue-autoextra';
import {extend} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import ListPart from "@/pages/Dashboard/Workshop/PKB/ComponentForm/modal/ListPart.vue";
import { Modal } from "@/components";

extend('partname', {
  ...required,
  message: 'Please Select. Part is required'
  });

export default {
  name: "service-card",

  props: ['pkb'],
  components: { Autoextra, Modal, "list-part": ListPart  },

  mixins: [formMixin],

  data () {
    return {
      part: [],
      index_modal: null,
      warehouse_id: null,
    }
  },
  
  created() {
          this.onOpen();
      },
   methods:{
     //fungsi yang dijalankan saat page pertama kali dibuka
     async onOpen(){
  
      },

      NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

    findPart(index){
        this.index_modal = index
        this.$refs.modalList.openModal({warehouse_id:this.warehouse_id})
      },
    
    //fungsi untuk menutup modal list client
      modalCloseList(data){
       console.log(data)
        this.$refs.modalList.closeModal()
        if(data.id){
          if(this.part[this.index_modal]){

              this.$set(this.part, this.index_modal, {
                        id : this.part[this.index_modal].id,
                        pkb_spare_part_master_id : data.id,
                        name : data.spare_part_master_name,
                        code : data.spare_part_master_code,
                        stock : data.spare_part_master_stock,
                        price : data.spare_part_master_unit_price,
                        pkb_spare_part_qty : this.part[this.index_modal].pkb_spare_part_qty,
                        pkb_spare_part_discount : this.part[this.index_modal].pkb_spare_part_discount,
                        total : (data.spare_part_master_unit_price * this.part[this.index_modal].pkb_spare_part_qty) - ((data.spare_part_master_unit_price* this.part[this.index_modal].pkb_spare_part_qty) * this.part[this.index_modal].pkb_spare_part_discount/100),
                        pkb_spare_part_remark : this.part[this.index_modal].pkb_spare_part_remark
                        
                      });


            }
            else{
              

              this.$set(this.part, this.index_modal, {
                      id : null,
                      pkb_spare_part_master_id : data.id,
                      name : data.spare_part_master_name,
                      code : data.spare_part_master_code,
                      stock : data.spare_part_master_stock,
                      price : data.spare_part_master_unit_price,
                      pkb_spare_part_qty : 1,
                      pkb_spare_part_discount : null,
                      total : data.spare_part_master_unit_price * 1,
                      pkb_spare_part_remark : null
                      
                    });
            }
        }
        
      },



      //fungsi untuk menghapus row sparepart
      deleteColumn(index){
        if (index > -1) {
           this.part.splice(index, 1)
            var filtered = this.part.filter(function (el) {
              return el != null;
            });
            this.part = filtered;
        }
        console.log(this.part);
        
      },

    
         //fungsi ketika ada perubahan di input qty, index nomor urut row
        qtyChange(index,qty){
          //check jika nilai qty tidak null
          if(qty){

          //set var part
           this.$set(this.part, index, {
                id : this.part[index].id,
                pkb_spare_part_master_id : this.part[index].pkb_spare_part_master_id,
                name : this.part[index].name,
                code : this.part[index].code,
                stock : this.part[index].stock,
                price : this.part[index].price,
                pkb_spare_part_qty : qty,
                pkb_spare_part_discount : this.part[index].pkb_spare_part_discount,
                total : (this.part[index].price * qty) - ((this.part[index].price * qty) * this.part[index].pkb_spare_part_discount/100),
                pkb_spare_part_remark : this.part[index].pkb_spare_part_remark
              });
            
          }

        },

         //fungsi ketika ada perubahan di input discount, index nomor urut row
        discountChange(index,discount){
           //check apakah nilai discount tidak null
          if(discount){
              this.$set(this.part, index, {
                id : this.part[index].id,
                pkb_spare_part_master_id : this.part[index].pkb_spare_part_master_id,
                name : this.part[index].name,
                code : this.part[index].code,
                stock : this.part[index].stock,
                price : this.part[index].price,
                pkb_spare_part_qty : this.part[index].pkb_spare_part_qty,
                pkb_spare_part_discount : discount,
                total : (this.part[index].price * this.part[index].pkb_spare_part_qty) - ((this.part[index].price * this.part[index].pkb_spare_part_qty) * discount/100),
                pkb_spare_part_remark : this.part[index].pkb_spare_part_remark
              });
            
            //console.log("discountChange");
          }

        },
        
        //fungsi yang di panggil dari sisi parent untuk mendapatkan data yang ada di page child ini
        getData() {
            this.$emit('data', this.part)
        },
        //fungsi untuk mendapatkan data dari parent
        async getDataParent(data,type,warehouse) {
          this.warehouse_id = warehouse;
          //for each data
          if(type == "add"){
            data.forEach(async (value, index) => {
              var query = { filter: { warehouse: warehouse, id: value.service_estimate_spare_part_master_id} };
              await this.$store.dispatch("workshop_spare_part_master/list", query);
            var dataStock =  await this.$store.getters["workshop_spare_part_master/list"];

            this.$set(this.part, index, {
                  id : null,
                  pkb_spare_part_master_id : value.service_estimate_spare_part_master_id,
                  name : value.part_master.spare_part_master_name,
                  code : value.part_master.spare_part_master_code,
                  stock : dataStock[0].spare_part_master_stock,
                  price : value.part_master.spare_part_master_unit_price,
                  pkb_spare_part_qty : value.service_estimate_spare_part_qty,
                  pkb_spare_part_discount :  value.service_estimate_spare_part_discount,
                  total : (value.part_master.spare_part_master_unit_price * value.service_estimate_spare_part_qty) - ((value.part_master.spare_part_master_unit_price * value.service_estimate_spare_part_qty) * value.service_estimate_spare_part_discount/100),
                  pkb_spare_part_remark : value.service_estimate_spare_part_remark
                });
          });
          }
          else{
            data.forEach(async (value, index) => {
              var query = { filter: { warehouse: warehouse, id: value.pkb_spare_part_master_id} };
              await this.$store.dispatch("workshop_spare_part_master/list", query);
            var dataStock =  await this.$store.getters["workshop_spare_part_master/list"];

                this.$set(this.part, index, {
                  id : value.id,
                  pkb_spare_part_master_id : value.pkb_spare_part_master_id,
                  name : value.spare_part_master_name,
                  code : value.spare_part_master_code,
                  stock : dataStock[0].spare_part_master_stock,
                  price : value.spare_part_master_unit_price,
                  pkb_spare_part_qty : value.pkb_spare_part_qty,
                  pkb_spare_part_discount :  value.pkb_spare_part_discount,
                  total : (value.spare_part_master_unit_price * value.pkb_spare_part_qty) - ((value.spare_part_master_unit_price * value.pkb_spare_part_qty) * value.pkb_spare_part_discount/100),
                  pkb_spare_part_remark : value.pkb_spare_part_remark
                });
          });
          }
          
          
        },
        //fungsi yang di panggil dari sisi parent untuk mengecheck validasi form di page child ini
        async validateForm() {
            const spare_part_master_name = this.$refs['spare_part_master_name'];
          let result = []
              if(this.part.length == 0){
            result.push(
                await spare_part_master_name.validate().then(function(data){
                return data.valid
                })
            )
              } 
            
            return result.every(Boolean)
          
    }
        

    },
    mounted() {
        console.log('Component mounted.')
    }
};
</script>

<style lang="scss" scoped>

.columns{
  margin-bottom: 3ex;
  border-bottom: 5px solid black;
}

.coba{
  width:800px !important;
  margin: 50px auto !important;
  
  @media screen and (max-width: 992px) {
      width: 90% !important;
    }
}
</style>
